export function matchBannerWidth() {
    // Get the elements
    const bannerColumn = document.querySelector('.is-style-width-masthead-banner');
    const referenceBanner = document.querySelector('.site-masthead__bottom-banner');
  
    if (bannerColumn && referenceBanner) {
      // Set the width of the bannerColumn to match the referenceBanner
      const updateWidth = () => {
        document.documentElement.style.setProperty('--banner-width', `${referenceBanner.offsetWidth}px`);
      };
  
      // Update the width initially
      setTimeout(updateWidth, 0.1);
  
      // Update the width on window resize
      window.addEventListener('resize', updateWidth);
    }
} 